<mat-dialog-content class="policy-option">
  <button
    mat-dialog-close
    class="o-modal-dismiss"
  >
    <epi-icon
      use="close"
      size="24"
    ></epi-icon>
  </button>
  <epi-heading
    level="2"
    appears-as="2"
    color="primary"
    class="policy-option__heading"
  >
  <p class="custom-plan__footer__amount is-header">
	<strong>{{ (data.activePet | async)?.totalPremium | currency }}</strong>
	<span class="custom-plan__footer__amount-small">
	  /{{ data.planModalityDisplay === 'Month' ? 'mo' : data.planModalityDisplay }}
	</span>
  </p>
    <strong>Customize Plan</strong>
   
  </epi-heading>
  <p class="policy-option__copy">Choose your reimbursement limit, deductible and reimbursement percentage
	<span class="policy-option__heading__tooltip">
		<svg class="policy-option__heading__tooltip-svg">
		  <use href="../../../assets/icons/info-mark-outline.svg#info"></use>
		</svg>
		<div class="policy-option__heading__tooltip-content">
		  <strong>Annual Reimbursement Limit</strong>
		  <p>The maximum amount Embrace will reimburse you each year.</p>
		  <br />
		  <strong>Annual Deductible</strong>
		  <p>The amount you'll pay yearly before Embrace starts reimbursing you.</p>
		  <br />
		  <strong>Reimbursement Percentage</strong>
		  <p>What Embrace will reimburse you after you've met your deductible.</p>
		</div>
	  </span>

  </p>
  
  <form [formGroup]="policyOptionsForm">
    <section class="custom-plan__form">
      <div
        [ngClass]="{ 'is--recalculating': recalculating$ | async }"
        class="custom-plan__toggles"
        role="presentation"
      >
        <epi-label class="select-label">Annual Reimbursement Limit</epi-label>
        <epi-option-toggle
          qeCustomInput
          formControlName="annualReimbursement"
          id="reimbursementLimitOptions"
          size="medium"
          layout="dense"
          data-quat="input_annualReimbursement"
        >
          <epi-toggle-choice
            *ngFor="let option of reimbursementLimit; let i = index"
            #annualReimbursementOption
            [attr.value]="option.rawValue"
            [attr.popular]="option.isPopular"
            slot="option"
            attr.data-quat="input_annualReimbursementOption{{ i }}"
            (click)="updateCoverage('annualReimbursement', annualReimbursementOption.value)"
          >
            {{ option.viewValue }}
          </epi-toggle-choice>
        </epi-option-toggle>
      </div>
      <div
        [ngClass]="{ 'is--recalculating': recalculating$ | async }"
        class="custom-plan__toggles"
        role="presentation"
      >
        <epi-label class="select-label">Annual Deductible</epi-label>
        <epi-option-toggle
          qeCustomInput
          formControlName="annualDeductible"
          id="deductibleOptions"
          size="medium"
          layout="dense"
          data-quat="input_annualDeductible"
        >
          <epi-toggle-choice
            *ngFor="let option of annualDeductible; let i = index"
            #annualDeductibleOption
            [attr.value]="option.rawValue"
            [attr.popular]="option.isPopular"
            slot="option"
            attr.data-quat="input_annualDeductibleOption{{ i }}"
            (click)="updateCoverage('annualDeductible', annualDeductibleOption.value)"
          >
            {{ option.viewValue }}
          </epi-toggle-choice>
        </epi-option-toggle>
      </div>
      <div
        [ngClass]="{
          'is--recalculating': recalculating$ | async
        }"
        class="custom-plan__toggles"
        role="presentation"
      >
        <epi-label class="select-label">Reimbursement Percentage</epi-label>
        <epi-option-toggle
          class="reimbursementOptions"
          qeCustomInput
          formControlName="reimbursementPercent"
          id="reimbursementPercentageOptions"
          size="medium"
          layout="dense"
          data-quat="input_reimbursementPercent"
        >
          <epi-toggle-choice
            *ngFor="let option of reimbursementPercent; let i = index"
            #reimbursementPercent
            [attr.value]="option.rawValue"
            [attr.popular]="option.isPopular"
            slot="option"
            attr.data-quat="input_reimbursementPercentOption{{ i }}"
            (click)="updateCoverage('reimbursement', reimbursementPercent.value)"
          >
            {{ option.viewValue }}
          </epi-toggle-choice>
        </epi-option-toggle>
      </div>
	  <div
	  class="u-row call-action"
	  role="presentation"
  >
	  <p class="u-row__column">
		  Call
		  <a
			  qeBaseLink
			  class="n--minimal select-policy__simplified__call-action__number"
			  href="tel:{{ brandUnformattedPhoneNumber$ | async }}"
		  >
			  {{ brandFormattedPhoneNumber$ | async }}</a>
		  for a complete list of options.
	  </p>
  </div>
    </section>
  </form>
	<section
	*ngIf="isExamFeesVisible || isRxCoverageVisible"
	formGroupName="optionalCoverages"
	class="optional-coverage"
>
	<h2 class="optional-coverage__heading">Optional Coverages</h2>
	<div
		*ngIf="isExamFeesVisible"
		class="optional-coverage__card m--exam-fees"
		role="presentation"
	>
		<div
			class="optional-coverage__header"
			role="presentation"
		>
			<div
				role="presentation"
				class="optional-coverage__label"
			>
				<img
					src="../../../assets/icons/records-illustration.svg"
					alt=""
				/>
				<label
					id="examFees"
					class="optional-coverage__label-text"
				>
					Exam Fees
				</label>
			</div>
			<div
				[ngClass]="{ 'is--toggled-off': !isExamFeesToggledOn }"
				class="optional-coverage__toggle"
				role="presentation"
			>
				<mat-slide-toggle
					[checked]="isExamFeesToggledOn"
					aria-labelledby="examFees"
					(change)="
						updateOptionalCoverage('examFeeCoverage', $event.checked)
					"
				>
				</mat-slide-toggle>
				<p>
					<span *ngIf="isExamFeesToggledOn">+</span>
					{{
					(activePet$ | async)?.examFeeCoverageDisplayPremium
					| currency
					}}/mo.
				</p>
			</div>
			<p class="optional-coverage__info">
				Make sure all accident and illness exam fees are covered.*
			</p>
		</div>
		<div
			role="presentation"
			class="optional-coverage__additional-info"
			[ngClass]="{ 'is--expanded': showAdditionalExamFeesInfo }"
		>
			<div
				role="presentation"
				class="optional-coverage__additional-info-container"
			>
				<p class="optional-coverage__additional-info-heading">
					What's this for?
				</p>
				<p class="optional-coverage__additional-info-copy">
					Your accident and illness exam fees get reimbursed. That&apos;s one
					less vet bill to worry about.
				</p>
				<p class="optional-coverage__additional-info-heading">
					Why it's important
				</p>
				<p>
					Pet parents can expect to pay anywhere from $50 to $100 for a
					vet exam. With exam fee coverage you can get your pet seen by a
					vet worry-free.
				</p>
				<small class="optional-coverage__additional-info-fine-print">*Routine exam fee coverage not
					included.</small>
			</div>
		</div>
		<button
			class="optional-coverage__expand"
			aria-label="Toggle to read additional information about the exam fee coverage you can add to your policy"
			(click)="showAdditionalExamFeesInfo = !showAdditionalExamFeesInfo"
		>
			<img
				class="optional-coverage__expand-icon"
				src="../../../assets/icons/carrot-outlined_brand-primary.svg"
				[ngClass]="{ 'is--expanded': showAdditionalExamFeesInfo }"
			/>
		</button>
	</div>
	<div
		*ngIf="isRxCoverageVisible"
		class="optional-coverage__card"
		role="presentation"
	>
		<div
			class="optional-coverage__header"
			role="presentation"
		>
			<div
				role="presentation"
				class="optional-coverage__label"
			>
				<img
					src="../../../assets/icons/rx-illustration.svg"
					alt=""
				/>
				<label
					id="rxCoverage"
					class="optional-coverage__label-text"
				>
					Prescription Drugs
				</label>
			</div>
			<div
				[ngClass]="{ 'is--toggled-off': !isRxCoverageToggledOn }"
				class="optional-coverage__toggle"
				role="presentation"
			>
				<mat-slide-toggle
					[checked]="isRxCoverageToggledOn"
					aria-labelledby="rxCoverage"
					(change)="updateOptionalCoverage('drugDental', $event.checked)"
				>
				</mat-slide-toggle>
				<p
					*ngIf="isRxCoverageAmountVisible"
				>
					<span *ngIf="!isRxCoverageToggledOn && isRxCoverageAmountVisible">+</span>
					{{
					(activePet$ | async)?.drugDentalDisplayPremium | currency
					}}/mo.
				</p>
			</div>
			<p class="optional-coverage__info">
				If your pet needs ongoing care, the cost of take-home drugs can
				add up.
			</p>
		</div>
		<div
			role="presentation"
			class="optional-coverage__additional-info"
			[ngClass]="{ 'is--expanded': showAdditionalRxCoverageInfo }"
		>
			<div
				role="presentation"
				class="optional-coverage__additional-info-container"
			>
				<p class="optional-coverage__additional-info-heading">
					What's this for?
				</p>
				<p class="optional-coverage__additional-info-copy">
					We reimburse for vet-prescribed drugs your pet needs to either
					manage or improve their condition covered by their policy.
				</p>
				<p class="optional-coverage__additional-info-heading">
					What we cover
				</p>
				<ul class="optional-coverage__additional-info-list">
					<li>Oral chemotherapy</li>
					<li>Allergy medication</li>
					<li>Insulin & supplies</li>
					<li>Anxiety medication</li>
					<li>Eye & ear drops</li>
					<li>Pain relievers</li>
					<li>Antibiotics</li>
					<li>Steroids</li>
				</ul>
			</div>
		</div>
		<button
			class="optional-coverage__expand"
			aria-label="Toggle to read additional information about the exam fee coverage you can add to your policy"
			(click)="
				showAdditionalRxCoverageInfo = !showAdditionalRxCoverageInfo
			"
		>
			<img
				class="optional-coverage__expand-icon"
				src="../../../assets/icons/carrot-outlined_brand-primary.svg"
				[ngClass]="{ 'is--expanded': showAdditionalRxCoverageInfo }"
			/>
		</button>
	</div>
</section>
<div
    class="custom-plan__footer u-margin-block-small"
    role="presentation"
  >
    <p class="custom-plan__footer__amount">
      <strong>{{ (data.activePet | async)?.totalPremium | currency }}</strong>
      <span class="custom-plan__footer__amount-small">
        /{{ data.planModalityDisplay === 'Month' ? 'mo' : data.planModalityDisplay }}
      </span>
    </p>
    <button
      qeBaseButton
      color="accent"
      class="custom-plan__footer__button u-margin-top-small"
      [ngClass]="{ 'is--recalculating': recalculating$ | async }"
      mat-dialog-close
    >
      Done
    </button>
  </div>
</mat-dialog-content>
